import React from "react";
import styles from "./styles/View.module.css";

export default function View(props) {
  return (
    <div style={props.style} ref={props.ref} onMouseLeave={props.onMouseLeave} onMouseEnter={props.onMouseEnter} className={`${styles.defaults} ${props.className} ${props.vertical && styles.vertical} ${props.centerVertically && styles.centerVertically} ${props.centerHorizontally && styles.centerHorizontally} ${props.pad === "small" && styles.padSmall} ${props.pad === "medium" && styles.padMedium} ${props.pad === "large" && styles.padLarge} ${props.gap === "small" && styles.gapSmall} ${props.gap === "medium" && styles.gapMedium} ${props.gap === "large" && styles.gapLarge} ${props.style}`}>{props.children}</div>
  );
}
